var _defs, _path, _path2, _g, _ellipse, _g2, _g3, _path3, _path4, _g4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermComplaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{opacity:.1;}.c{fill:#05f;}.d{fill:#04c;}.e{fill:#fff;}.f{fill:#ff6b00;}.g{opacity:.8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M402.91,406.23H97.09c-1.84,0-3.32-1.49-3.32-3.32V97.09c0-1.84,1.49-3.32,3.32-3.32H402.91c1.84,0,3.32,1.49,3.32,3.32V402.91c0,1.84-1.49,3.32-3.32,3.32Zm-302.49-6.65H399.58V100.42H100.42V399.58Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M250,322.47c-33.1,0-60.04-26.93-60.04-60.04v-14.22c0-33.1,26.93-60.04,60.04-60.04s60.03,26.93,60.03,60.04v14.22c0,33.1-26.93,60.04-60.03,60.04Zm0-127.65c-29.44,0-53.39,23.95-53.39,53.39v14.22c0,29.44,23.95,53.39,53.39,53.39s53.38-23.95,53.38-53.39v-14.22c0-29.44-23.94-53.39-53.38-53.39Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M196.81,223.41c0-14.69,11.9-26.59,26.59-26.59h0c14.69,0,26.59,11.9,26.59,26.59v66.48c0,14.69-11.9,26.59-26.59,26.59h0c-14.69,0-26.59-11.9-26.59-26.59v-66.48Z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 250,
    cy: 323.13,
    rx: 33.24,
    ry: 26.59
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M176.34,297.27h-8.18c-15.36,0-27.85-12.5-27.85-27.86s12.49-27.85,27.85-27.85h8.18c1.84,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32h-8.18c-11.69,0-21.2,9.51-21.2,21.2s9.51,21.21,21.2,21.21h8.18c1.84,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M331.84,297.27h-8.18c-1.84,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32h8.18c11.69,0,21.21-9.52,21.21-21.21s-9.52-21.2-21.21-21.2h-8.18c-1.84,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32h8.18c15.36,0,27.86,12.49,27.86,27.85s-12.5,27.86-27.86,27.86Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M277.26,338.15h-7.31c-1.84,0-3.32-1.49-3.32-3.32s1.49-3.32,3.32-3.32h7.31c23.76,0,43.08-19.32,43.08-43.08v-44.54c0-38.79-31.55-70.34-70.33-70.34s-70.34,31.55-70.34,70.34v44.54c0,1.84-1.49,3.32-3.32,3.32s-3.32-1.49-3.32-3.32v-44.54c0-42.45,34.53-76.99,76.99-76.99s76.98,34.53,76.98,76.99v44.54c0,27.42-22.31,49.73-49.73,49.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M234.77,323.66c0-6.18,5.05-11.24,11.24-11.24h19.21v22.4h-19.21c-6.18,0-11.24-4.99-11.24-11.17h0Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M265.22,312.43h3.32c0-1.8-1.53-3.32-3.32-3.32v3.32Zm0,22.4v3.32h3.32v-3.32h-3.32Zm-19.21-19.08h19.21v-6.65h-19.21v6.65Zm15.89-3.32v22.4h6.65v-22.4h-6.65Zm3.32,19.08h-19.21v6.65h19.21v-6.65Zm-19.21,0c-4.39,0-7.91-3.52-7.91-7.85h-6.65c0,7.98,6.52,14.49,14.56,14.49v-6.65Zm0-22.4c-8.04,0-14.56,6.52-14.56,14.56h6.65c0-4.39,3.52-7.91,7.91-7.91v-6.65Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M249.59,285.34c-7.16,0-14.19-3.12-22.81-9.38-1.49-1.08-1.82-3.16-.75-4.64,1.08-1.51,3.17-1.8,4.64-.75,15.05,10.9,22.65,10.87,38.73-.05,1.51-1.02,3.58-.65,4.62,.88,1.03,1.52,.64,3.58-.88,4.62-9.13,6.21-16.41,9.32-23.55,9.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermComplaint);
export default __webpack_public_path__ + "static/media/term_complaint.91f69ab6b065d7dc14a37070d08032c3.svg";
export { ForwardRef as ReactComponent };